type XCloseIconProps = {
  size?: number
}

export function XCloseIcon({ size = 24 }: XCloseIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M15.47 3.46985C15.7629 3.17695 16.2377 3.17695 16.5306 3.46985C16.8234 3.76275 16.8234 4.23752 16.5306 4.53039L11.0608 10.0001L16.5306 15.4698C16.8231 15.7628 16.8233 16.2376 16.5306 16.5304C16.2377 16.823 15.7628 16.8229 15.47 16.5304L10.0003 11.0607L4.53055 16.5304C4.23764 16.8228 3.76275 16.8231 3.47 16.5304C3.17727 16.2377 3.17759 15.7628 3.47 15.4698L8.93973 10.0001L3.47 4.53039C3.17719 4.23758 3.17734 3.76276 3.47 3.46985C3.7629 3.17695 4.23766 3.17695 4.53055 3.46985L10.0003 8.93957L15.47 3.46985Z" fill="currentColor" />
    </svg>
  )
}
